import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { createRefetchContainer, graphql } from 'react-relay';
import { updateRelayVariables } from '../../actions/sharedRelayVariableActions';

const isAllowedPageNumber = pageNumber => pageNumber % 3 === 1;

class SbSharedFollowSearchProviderComponent extends React.Component {
    constructor(props) {
        super(props);

        this.refetchFollow = this.refetchFollow.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.itemSearch.displayUriRef !== prevProps.itemSearch.displayUriRef &&
            this.props.fetchUser
        ) {
            this.props.relay.refetch();
        }
    }

    refetchFollow(callback = () => {}) {
        return this.props.relay.refetch(null, null, () => callback());
    }

    render() {
        const { itemSearch, page: pageNumber, searchTerm } = this.props;
        const { canFollowSearch } = itemSearch;
        /*
            show for:
                - page type can follow search (from graphql)
                - if the user isn't already following this search
                - first page and then every three pages
        */
        const showFollowButton = canFollowSearch && isAllowedPageNumber(pageNumber);
        const isFollowing = !!get(this.props, 'user.favorites.edges[0].node.serviceId');
        const followSearchValue = searchTerm || get(itemSearch, 'meta.header');
        const isCategorySearch = !searchTerm;

        return this.props.children({
            showFollowButton,
            isFollowing,
            followSearchValue,
            refetchFollow: this.refetchFollow,
            isCategorySearch,
        });
    }
}

SbSharedFollowSearchProviderComponent.propTypes = {
    uriRef: PropTypes.string,
    fetchUser: PropTypes.bool.isRequired,
    itemSearch: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
    user: PropTypes.object,
    searchTerm: PropTypes.string,
    updateRelayVariables: PropTypes.func,
    children: PropTypes.func.isRequired,
};

function mapStateToProps({ relayVariables }) {
    return {
        fetchUser: get(relayVariables, 'variables.fetchUser'),
    };
}

export const SbSharedFollowSearchProvider = createRefetchContainer(
    connect(mapStateToProps, { updateRelayVariables })(SbSharedFollowSearchProviderComponent),
    {
        itemSearch: graphql`
            fragment SbSharedFollowSearchProvider_itemSearch on ItemSearchQueryConnection {
                canFollowSearch
                displayUriRef
                meta {
                    header
                }
            }
        `,
        user: graphql`
            fragment SbSharedFollowSearchProvider_user on User {
                favorites(first: 1, types: $followSearchTypes, pages: $followSearchPages) {
                    ...FollowSearchButton_favoritesConnection
                    edges {
                        node {
                            serviceId
                        }
                    }
                }
            }
        `,
    },
    graphql`
        query SbSharedFollowSearchProviderRefetchQuery(
            $followSearchPages: [String]
            $userId: String = ""
            $followSearchTypes: [types] = [SEARCH]
        ) {
            viewer {
                user(userId: $userId) {
                    ...SbSharedFollowSearchProvider_user
                }
            }
        }
    `
);
